export const SUCCESS = 'success';
export const WARNING = 'warning';
export const ERROR = 'error';

export const RESPONSE_STATUS = {
  SUCCESS,
  WARNING,
  ERROR,
};
